'use strict'

const maybe = require('folktale/maybe')

const { Repeater } = require('dbsm-common/src/componentTypes')

// isContainerType :: Type -> Bool
const isContainerType = type => [Repeater].includes(type)

// Component = { id, component, role, children, parent }
// findContainer :: Component -> Maybe Container
const findContainer = component => {
  const parent = maybe
    .fromNullable(component)
    .chain(({ parent }) => maybe.fromNullable(parent))
  const container = parent.filter(({ type }) => isContainerType(type))
  return container.orElse(() => parent.chain(parent => findContainer(parent)))
}

module.exports.findContainer = findContainer



// WEBPACK FOOTER //
// ./dataset-controller/findContainers.js